import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bd5d7d0")

_pushScopeId("data-v-1bd5d7d0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Uw bruto jaarloon inclusief vakantiegeld, 13e maand of eindjaarsuikering ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Uw loon is de basis voor de berekening van uw uitkering. Uw verzekerd loon is uw jaarloon inclusief vakantiegeld, 13e maand, eindejaarsuitkering of andere vaste delen van uw loon. Loon uit overwerk hoeft u niet in te vullen en wordt niet meegerekend. Weet u niet wat uw bruto jaarloon is? Klik dan op ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(". ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Explain = _resolveComponent("Explain")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_SalaryCalculator = _resolveComponent("SalaryCalculator")
  const _component_Step = _resolveComponent("Step")

  return (_openBlock(), _createBlock(_component_Step, {
    step: _ctx.step,
    title: _ctx.title
  }, {
    default: _withId(() => [
      (!_ctx.useCalculator)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("p", null, [
              _hoisted_1,
              _createVNode(_component_Explain, { title: "Wat is uw loon?" }, {
                default: _withId(() => [
                  _hoisted_2,
                  _createVNode("a", {
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleCalculator(...args)))
                  }, "“ik weet mijn bruto jaarloon niet”"),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_CurrencyInput, {
              modelValue: _ctx.state.salary,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.state.salary = $event)),
              label: "euro per jaar"
            }, null, 8, ["modelValue"]),
            _createVNode("p", null, [
              _createVNode("a", {
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.toggleCalculator(...args)))
              }, "Bereken uw jaarloon met uw bruto maandloon")
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createBlock(_component_SalaryCalculator, {
            key: 1,
            modelValue: _ctx.state.salary,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.state.salary = $event))
          }, null, 8, ["modelValue"]))
    ]),
    _: 1
  }, 8, ["step", "title"]))
})